import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import { LoadingProvider } from './providers/loading'

import GlobalLoader from './components/global-loader'

import SearchPage from './pages/search'
import DiagramsPage from './pages/diagrams'
import DiagramPage from './pages/diagram'

import useIframeAutoHeight from './utils/useIframeAutoHeight';

import './assets/scss/global.scss'

// ✅ Only load the shim in development
if (process.env.NODE_ENV !== 'production') {
  require('./parentShim.local');
}

function IframeAutoHeightPinger() {
  useIframeAutoHeight();
  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <SnackbarProvider maxSnack={3}>
      <LoadingProvider>
        <Router>
          <IframeAutoHeightPinger />
          <GlobalLoader />
          <Routes>
            <Route path='/' element={<SearchPage screenHeight={false} />} />
            <Route path='/diagrams' element={<DiagramsPage />} />
            <Route path='/diagram' element={<DiagramPage />} />
          </Routes>
        </Router>
      </LoadingProvider>
    </SnackbarProvider>
  </React.StrictMode>
)
